import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fe6c05f6")

_pushScopeId("data-v-fe6c05f6")
const _hoisted_1 = { class: "empty" }
const _hoisted_2 = { class: "empty__text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OButton = _resolveComponent("OButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.text), 1),
    _createVNode(_component_OButton, {
      class: "empty__reload p-button-secondary",
      icon: "pi pi-refresh",
      "icon-pos": "right",
      label: "Recarregar",
      onClick: _ctx.reloadCb
    }, null, 8, ["onClick"])
  ]))
})